module.exports = __webpack_public_path__ + "img/Oman.0f4bfb78.png";